/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateFineThresholdSettings } from '../models/CreateFineThresholdSettings';
import type { FineThresholdSettings } from '../models/FineThresholdSettings';
import type { GetFineThresholdSettingsResponse } from '../models/GetFineThresholdSettingsResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class FineThresholdSettingsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns GetFineThresholdSettingsResponse OK
     * @throws ApiError
     */
    public getThresholdSettings({
        ownerType,
        ownerId,
    }: {
        ownerType: 'SHOP' | 'FINANCIER',
        ownerId: string,
    }): CancelablePromise<GetFineThresholdSettingsResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/fine-threshold/settings/{ownerType}/{ownerId}',
            path: {
                'ownerType': ownerType,
                'ownerId': ownerId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public updateFineThresholdSettings({
        requestBody,
    }: {
        requestBody: FineThresholdSettings,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/v2/fine-threshold/settings/{ownerType}/{ownerId}',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public createFineThresholdSettings({
        requestBody,
    }: {
        requestBody: CreateFineThresholdSettings,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v2/fine-threshold/settings/{ownerType}/{ownerId}',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public deleteFineThresholdSettings({
        ownerId,
        ownerType,
        settingsId,
    }: {
        ownerId: string,
        ownerType: 'SHOP' | 'FINANCIER',
        settingsId: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/v2/fine-threshold/settings/{ownerType}/{ownerId}/{settingsId}',
            path: {
                'ownerId': ownerId,
                'ownerType': ownerType,
                'settingsId': settingsId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
}
